function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 4)",
  stroke: "#E15D29",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 4.8V8M8 11.2h.008"
})));

function SvgInfoOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOrange);
export default __webpack_public_path__ + "static/media/info_orange.3d385581.svg";
export { ForwardRef as ReactComponent };